module.exports = __webpack_public_path__ + "img/client_4.8fda4462.png";